import React from "react";
import Picture, { type ImgSet } from "./Picture";
import { galleryImgSet } from "../lib/mainImages";

export type StripItem =
  | { kind: "supplier"; img: ImgSet; alt: string; caption?: string; responsiveVariantByViewport?: boolean }
  | { kind: "main"; file: string; alt: string };

interface ImageStripProps {
  items: StripItem[];
  testId?: string;
}

const ImageStrip: React.FC<ImageStripProps> = ({ items, testId }) => (
  <div className="image-strip" data-testid={testId}>
    {items.map((it, i) => {
      if (it.kind === "supplier") {
        return (
          <figure className={`image-strip-item${it.caption ? " image-strip-item-captioned" : ""}`} key={i}>
            <Picture
              src={it.img}
              alt={it.alt}
              width={1200}
              height={it.responsiveVariantByViewport ? 900 : 750}
              sizes="(max-width: 768px) 100vw, 33vw"
              responsiveVariantByViewport={it.responsiveVariantByViewport}
            />
            {it.caption && <figcaption className="project-photo-caption">{it.caption}</figcaption>}
          </figure>
        );
      }
      const g = galleryImgSet(it.file);
      return (
        <div className="image-strip-item" key={i}>
          <Picture
            src={g.imgSet}
            alt={it.alt}
            width={g.displayWidth}
            height={g.displayHeight}
            srcWidths={g.srcWidths}
            sizes="(max-width: 768px) 100vw, 33vw"
          />
        </div>
      );
    })}
  </div>
);

export default ImageStrip;
